import React, { useEffect, useState } from 'react';
import type { ICellRendererParams } from 'ag-grid-community';
import { RootState, useDispatch, useSelector } from '../../redux/store';

/**
 * emailからユーザ名を表示するレンダラ
 * @param params: ICellRendererParams
 * @returns React.ReactElement
 */
const UserNameFromEmailCellRenderer = (params: ICellRendererParams): React.ReactElement => {
  // console.log(params);
  const userEmail: string = params.value;
  const { users } = useSelector((state: RootState) => state.user);
  const [userName, setUserName] = useState<string>(userEmail);

  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  // }, []);

  useEffect(() => {
    if (users !== undefined) {
      const name: string | undefined = users.find((user) => user.email === userEmail)?.username;
      setUserName(name ?? userEmail);
    }
  }, [users]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return <div className="user-name">{userName}</div>;
};

export default UserNameFromEmailCellRenderer;
